import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/sharp-duotone-solid-svg-icons';
import { FC, useContext, useEffect, useState } from 'react';
import { blobPath } from 'constants/constant';
import { MainContext } from 'contexts/MainContext';
import { b2b, defaultLoaderUrl } from 'constants/generic';

export const LoadingBlock: FC = () => {
  const {
    cdnUrl,
    isEnigma,
    initSiteData
  } = useContext(MainContext);
  const [loading, setLoading] = useState<any>();

  useEffect(() => {
    const allLoading = JSON.parse(localStorage.getItem('allLoadings') || '{}');
    const newLoading = allLoading?.loadings?.find(
      (item: any) =>
        item?.loadingPage.systemProducts === 'Hotels' &&
        item?.loadingPage.systemProductsDetails === 'LoadingDetails'
    );

    setLoading(newLoading);
  }, []);
  return (
    <div className="position-relative w100p">
      {!!loading && !b2b && (
        <div className="flex-center">
          {!!loading?.loadingPage.listOfGalleryId?.[0].code && (
            <img
              style={{ maxHeight: 200, maxWidth: '100%', objectFit: 'contain' }}
              src={cdnUrl + blobPath + loading.loadingPage.listOfGalleryId[0].code}
              alt="load"
            />
          )}
        </div>
      )}
      {b2b && (
        <div className="loader-main-content">
          <img
            alt="logo"
            src={
              (cdnUrl || '') + (isEnigma ? initSiteData?.other?.logoUrl || '' : initSiteData?.other?.mainLoaderUrl || initSiteData?.other?.defaultLoaderUrl || defaultLoaderUrl || '')
            }
          />
          <FontAwesomeIcon icon={faSpinnerThird as any} spinPulse />
        </div>
      )}
    </div>
  );
};

export default LoadingBlock;
